import CartItemsContainer from "../../components/cart/cart-items-container";

const Cotizacion = () => {
    return (
    <CartItemsContainer/>
    )
}

export default Cotizacion;